<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      {{ $t('Verify Two-Factor Authentication code') }}
    </div>

    <div class="panel-body text-center p-b-0">
      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <BaseHtmlForm
        action="/login/2fa"
        method="post"
        class="form-group m-b-10 p-20"
        style="background-color: #f7f7f9; padding-top: 8px; padding-bottom: 8px"
        append-user-and-account
      >
        <label for="codeVerify" style="color: #0e1a9a">
          <template v-if="type === 'sms'">
            {{ $t('Enter the verification code sent to your phone by sms') }}
          </template>
          <template v-else>
            {{ $t('Enter the verification code generated by your mobile application') }}
          </template>
        </label>
        <input
          id="codeVerify"
          v-model="verifyCode"
          autofocus
          name="code"
          style="width: 85px; display: block; margin-left: auto; margin-right: auto"
          type="text"
          pattern="\d*"
          class="form-control text-center"
          maxlength="7"
          minlength="6"
          placeholder="12 345 67"
        />
        <button type="submit" class="btn btn-primary m-t-10">
          {{ $t('Verify code') }}
        </button>
      </BaseHtmlForm>
      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <BaseHtmlForm
        v-if="type !== 'sms'"
        method="post"
        action="/login/2fa/force-sms"
        class="m-20"
        append-user-and-account
      >
        <button type="submit" class="btn btn-sm btn-link c-indigo-500 ncase m-b-10">
          {{ $t('Send SMS instead') }}
        </button>
      </BaseHtmlForm>
    </div>
    <!-- panel body -->
  </div>
  <!-- panel -->
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'app',
    },
  },
  data() {
    return {
      verifyCode: null,
    }
  },
}
</script>

<style scoped></style>
